
import Tooltip from '@material-ui/core/Tooltip';
import GridOffIcon from '@material-ui/icons/GridOff';
import GridOnIcon from '@material-ui/icons/GridOn';

export default function TableOutlineToggleButton({tableOutlineShowing,setTableOutlineShowing}){

  return (

<Tooltip title={(tableOutlineShowing?"Hide":"Show") + " Gridlines"}>
                <div class="outline-toggler">
                  <div
                    onClick={() => setTableOutlineShowing(!tableOutlineShowing)}
                    class="outline-toggler tiny-padding hoverable clickable-text toolbar-button">
                    {tableOutlineShowing && <GridOffIcon/>}
                    {!tableOutlineShowing && <GridOnIcon/>}
                  </div>
                </div>
              </Tooltip>
  )

}
